export default {
  custom_option: 'Aangepast',
  zero_option: 'Geen fooi',
};
